import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "fill"]
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'startIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#57B755",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: __props.color
  }, [
    _createElementVNode("path", {
      d: "M13.5349 5.57594C13.474 5.40621 13.3624 5.25925 13.2154 5.15493C13.0683 5.05061 12.8927 4.99395 12.7124 4.99261H9.15987C9.09993 4.99258 9.04145 4.97409 8.9924 4.93964C8.94334 4.9052 8.90609 4.85648 8.8857 4.80011L7.61404 1.18344C7.54777 1.01962 7.43407 0.879344 7.28751 0.780604C7.14096 0.681863 6.96825 0.629165 6.79154 0.629273C6.61181 0.630133 6.43676 0.686691 6.2905 0.791159C6.14425 0.895628 6.03398 1.04287 5.97487 1.21261L4.69737 4.81177C4.67699 4.86814 4.63974 4.91687 4.59068 4.95131C4.54162 4.98575 4.48315 5.00425 4.4232 5.00427H0.870705C0.690179 5.00478 0.51423 5.06111 0.366978 5.16555C0.219725 5.26998 0.10838 5.4174 0.0482049 5.58761C-0.00966169 5.75586 -0.0155718 5.93762 0.0312428 6.10928C0.0780575 6.28093 0.175431 6.43453 0.310705 6.55011L3.33237 9.05844C3.37777 9.09549 3.41096 9.14536 3.42761 9.20155C3.44426 9.25774 3.44359 9.31763 3.4257 9.37344L2.15404 13.1826C2.09415 13.359 2.0921 13.5499 2.1482 13.7275C2.20429 13.9051 2.3156 14.0602 2.46592 14.1701C2.61625 14.2801 2.79775 14.3393 2.98401 14.339C3.17027 14.3386 3.35157 14.2789 3.50154 14.1684L6.61654 11.8818C6.66612 11.8444 6.72653 11.8242 6.78862 11.8242C6.85072 11.8242 6.91112 11.8444 6.9607 11.8818L10.0815 14.1684C10.2303 14.2923 10.416 14.3632 10.6095 14.3702C10.8029 14.3773 10.9932 14.3199 11.1506 14.2072C11.308 14.0945 11.4236 13.9328 11.4792 13.7474C11.5349 13.562 11.5275 13.3634 11.4582 13.1826L10.1865 9.37344C10.1686 9.31763 10.168 9.25774 10.1846 9.20155C10.2013 9.14536 10.2345 9.09549 10.2799 9.05844L13.3074 6.54427C13.4384 6.42458 13.5303 6.26808 13.5709 6.09529C13.6115 5.9225 13.5989 5.74147 13.5349 5.57594Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})